import React from "react";
import css from "./index.module.scss";
import Link from "next/link";

export default function SellerFaq({}) {
  return <section className={`light ${css.faq}`}>
    <div className="sectionInner">
      <h2>Seller FAQ</h2>
      <h4>What share do I get from sales?</h4>
      <p>Prompt engineers receive 80% of the sale, after Stripe transaction fees (2.9% + $0.30).</p>
      <h4>How do I get paid?</h4>
      <p>Lazy Prompts partners with Stripe for billing. As part of setting up your seller account, you will be asked to link your bank account via Stripe. Payments are made directly to your bank account.</p>
      <h4>How will I know how many sales I&apos;ve made?</h4>
      <p>After registering as a seller, you will have access to a dashboard of all your listings, including how many times each listing sold.</p>
      <h4>How do I get my prompts featured?</h4>
      <p>Featured prompts are handpicked by the Lazy Prompts team. If you want yours to be considered, make sure it has high-quality examples, a good description, and produces reliable, consistent output. To submit your prompt for consideration, <Link href="/contact">contact us</Link>.</p>
      <h4>How long does it take for my prompt to be approved?</h4>
      <p>Up to one week.</p>
    </div>
  </section>;
}

